<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Editar registro de llegada de Autotanque
        .columns
          .column.is-1
            input#inpFull.is-checkradio(type='checkbox' v-model='isFull')
            label.is-size-6(for='inpFull') Full
          .column.is-3
            TypeaheadPG(:options="autotanquesBD" :optionSelect="itemSelAuto" v-model="itemSelAuto")
          .column.is-2
            a.button.is-rounded(@click="checkForm" :disabled="isDisabled" :class="classFull")
              | Actualizar Autotanque
          .column.is-2
            a.button.is-rounded(@click="cancelarUpdate")
              | Cancelar
        .columns
          .column.is-2
            span Autotanques Seleccionados:
          .column.is-10
            div.field.is-grouped.is-grouped-multiline
              div.control(v-for="(at, index) in autotanquesSel" :key="index")
                div.tags.has-addons
                  span.tag
                    | {{ at.pg }}
                    button.delete(@click="borrarAT(at)")

</template>

<script>
  import NavBar from './layout/NavBar'
  import Loader from '@/components/shared/Loader.vue'
  import TypeaheadPG from './componentes/TypeaheadPG'
  import accesos_tpaServices from '@/services/sca/accesos/accesosTPA.js'
  import moment from 'moment'
  import { mapState } from 'vuex'
  export default {
    name: 'EditarAcceso',
    components: { NavBar, Loader, TypeaheadPG },
    data() {
      return {
        isLoading: true,
        autotanquesBD: [],
        itemSelAuto: {},
        autotanquesSel: [],
        fechaJornada: '',
        isFull: false,
        isDisabled: false,
        classFull: 'is-warning',
        claveAcceso: '',
        numAT: 0,
        itemsGuardados: 0,
        fechaRegistro: '',
        isFullOld: false
      }
    },
    watch: {
      isFull() {
        this.checkNumTanques()
        this.checkAutotanque()
      },
      itemSelAuto () {
        this.checkAutotanque()
      }
    },
    methods: {
      iniciarComponente() {
        this.tpaAccesoEditar.map( acc => {
          const { pg } = acc
          const myObt = {
            pg: pg
          }
          this.autotanquesSel.push(myObt)
          this.fechaRegistro = acc.fechaLlegada
          this.claveAcceso = acc.claveAcceso
          this.fechaJornada = acc.fechaReporte
          this.checkNumTanques()
        })
        this.isFull = this.autotanquesSel.length == 2 ? true : false
        this.isFullOld = this.isFull
        this.obtenerAutotanques()
      },
      
      obtenerAutotanques() {
        accesos_tpaServices.getAccesos_autotanques()
          .then( data => {
            this.autotanquesBD = data
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },
      updateRegistro () {

        if (this.isDisabled) {
          return
        }
        
        this.isLoading = true

        if (this.isFullOld) {
          if (this.isFull) {
            this.updateAccesos()
          } else {
            this.isLoading = true
            accesos_tpaServices.updateAcceso(this.tpaAccesoEditar[0].id,this.autotanquesSel[0].pg)
              .then( dataUpd => {
                if (dataUpd.success) {
                  accesos_tpaServices.deleteAcceso(this.tpaAccesoEditar[1].id)
                    .then( data => {
                      if (data.success) {
                        this.displayToast('toasted-primary', 'Autotanques Registrados correctamente', 'done', 'OK')
                        this.$router.push('/TPA/SCA/Accesos')
                      } else {
                        this.displayToast('bubble',`Error: No se pudo modificar el acceso.`, 'ban', 'OK')
                      }
                    })
                    .catch(e => {
                      this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                      this.isLoading = false
                    })
                  
                } else {
                  this.displayToast('bubble', dataUpd.message, 'ban', 'OK')
                }
                this.isLoading = false
              })
              .catch(e => {
                this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                this.isLoading = false
              })
            
          }
        } else {
          if (this.isFull) {
            this.isLoading = true
            accesos_tpaServices.updateAcceso(this.tpaAccesoEditar[0].id,this.autotanquesSel[0].pg)
              .then( dataUpd => {
                if (dataUpd.success) {
                  accesos_tpaServices.registrarAcceso(this.fechaRegistro, this.fechaJornada, this.autotanquesSel[1].pg, 0, this.userLogin.id, this.userLogin.nombre, this.claveAcceso)
                    .then( data => {
                      if (data.success) {
                        this.displayToast('toasted-primary', 'Autotanques Registrados correctamente', 'done', 'OK')
                        this.$router.push('/TPA/SCA/Accesos')
                      } else {
                        this.displayToast('bubble',`Error: No se pudo modificar el acceso.`, 'ban', 'OK')
                      }
                    })
                    .catch(e => {
                      this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                      this.isLoading = false
                    })
                  
                } else {
                  this.displayToast('bubble', dataUpd.message, 'ban', 'OK')
                }
                this.isLoading = false
              })
              .catch(e => {
                this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                this.isLoading = false
              })
          } else {
            this.isLoading = true
            accesos_tpaServices.updateAcceso(this.tpaAccesoEditar[0].id,this.autotanquesSel[0].pg)
              .then( data => {
                if (data.success) {
                  this.displayToast('toasted-primary', 'Autotanques Registrados correctamente', 'done', 'OK')
                  this.$router.push('/TPA/SCA/Accesos')
                } else {
                  this.displayToast('bubble', 'Error al modificar los accesos.', 'ban', 'OK')
                }
                this.isLoading = false
              })
              .catch(e => {
                this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                this.isLoading = false
              })
          }
        }
      },

      updateAccesos () {
        if (this.itemsGuardados == this.numAT ) {
          this.isLoading = false
          this.displayToast('toasted-primary', 'Autotanques Registrados correctamente', 'done', 'OK')
          this.$router.push('/TPA/SCA/Accesos')
          return
        } else {
          this.isLoading = true
          accesos_tpaServices.updateAcceso(this.tpaAccesoEditar[this.itemsGuardados].id,this.autotanquesSel[this.itemsGuardados].pg)
            .then( data => {
              if (data.success) {
                this.itemsGuardados = this.itemsGuardados + 1
              } else {
                this.itemsGuardados = this.itemsGuardados + 1
                this.displayToast('bubble', `Error: ${data.respuesta}`, 'ban', 'OK')
                this.isLoading = false
              }
              this.updateAccesos()
            })
            .catch(e => {
              this.itemsGuardados = this.itemsGuardados + 1
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
              this.updateRegistro()
            })
        }
      },

      async updateAcceso_Ind(index) {
        this.isLoading = true
        const data = await accesos_tpaServices.updateAcceso(this.tpaAccesoEditar[index].id,this.autotanquesSel[index].pg)
          .then( data => {
            this.isLoading = false
            console.log(data.success)
            return data.success
          })
          .catch(e => {
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
            this.isLoading = false
            return false
          })
      },

      async deleteAcceso_Ind(index) {
        this.isLoading = true
        accesos_tpaServices.deleteAcceso(this.tpaAccesoEditar[index].id)
          .then( data => {
            console.log(data)
            this.isLoading = false
            console.log(data.success)
            return data.success
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
            return false
          })
      },

      async insertAcceso_Ind(index) {
        this.isLoading = true
        accesos_tpaServices.registrarAcceso(this.fechaReg, this.fechaJornada, this.autotanquesSel[index].pg, 0, this.userLogin.id, this.userLogin.nombre, this.claveAcceso)
          .then( data => {
            console.log(data)
            console.log(data.success)
            return data.success
          })
          .catch(e => {
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
            return false
          })
      },

      checkAutotanque () {
        if (Object.keys(this.itemSelAuto).length > 0) {
          if (this.isFull) {
            let existe = false
            if (this.autotanquesSel.length == 1 ) {
              existe = this.autotanquesSel.some( at => at.pg === this.itemSelAuto.pg)
            }
            if (!existe) {
              this.autotanquesSel.push(this.itemSelAuto)
            }
            this.autotanquesSel.length < 2 ? this.classFull = '' : this.classFull = 'is-black'
            this.autotanquesSel.length == 2 ? this.isDisabled = false : this.isDisabled = true

          } else {
            this.autotanquesSel = []
            this.autotanquesSel.push(this.itemSelAuto)
            this.autotanquesSel.length < 1 ? this.classFull = '' : this.classFull = 'is-black'
            this.autotanquesSel.length == 1 ? this.isDisabled = false : this.isDisabled = true
          }
        }
        if (!this.isFull) {
          if (this.autotanquesSel.length == 2) {
            this.autotanquesSel.splice(1)
          }
        }
      },

      checkForm () {
        if (this.autotanquesSel.length == this.numAT) {
          this.updateRegistro()
        } else {
          if (this.autotanquesSel.length == 0) {
            this.displayToast('bubble', 'Debe Seleccionar al menos un autotanque.', 'ban', 'OK')
          }
        }
      },

      checkNumTanques () {
        this.isFull ? this.numAT = 2 : this.numAT = 1
      },

      borrarAT (at) {
        const newArr = this.autotanquesSel.filter( aut => aut.pg !== at.pg)
        newArr.length > 0 ? this.autotanquesSel = newArr : this.autotanquesSel = []
        this.itemSelAuto = {}
      },

      cancelarUpdate () {
        this.$store.commit('editarEmb_IRGE', {})
        this.$router.back()
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'tpaAccesoEditar'])
    }

  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/accesos/EditAccesos.vue